import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c37d7c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "navbar navbar-expand-sm navbar-light",
  style: {"background-color":"#a9a39b"}
}
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "mobile-button" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-bars" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 0,
  id: "navbarSupportedContent",
  class: "collapse navbar-collapse items-baseline"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-wrap justify-around sm:flex-nowrap sm:space-x-5" }, null, -1))
const _hoisted_8 = { class: "nav navbar-nav ml-auto items-baseline" }
const _hoisted_9 = {
  key: 0,
  src: "/img/ITflag.png",
  class: "mr-10"
}
const _hoisted_10 = {
  key: 1,
  src: "/img/ENflag.png",
  class: "mr-10"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "it-IT" }, " ITALIANO ", -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 2,
  class: "font-bold project-tag navitemUser"
}
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Login ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Logout ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavBarItem = _resolveComponent("NavBarItem")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("a", {
          class: "btn btn-primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggleSidebar')))
        }, _hoisted_5)
      ]),
      (!_ctx.isCollapsed)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              (_ctx.$i18n.locale === 'it-IT')
                ? (_openBlock(), _createElementBlock("img", _hoisted_9))
                : _createCommentVNode("", true),
              (_ctx.$i18n.locale === 'en-US')
                ? (_openBlock(), _createElementBlock("img", _hoisted_10))
                : _createCommentVNode("", true),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.$i18n.locale) = $event)),
                class: "mr-10",
                style: {"background-color":"#a9a39b"}
              }, _hoisted_12, 512), [
                [_vModelSelect, _ctx.$i18n.locale]
              ]),
              (_ctx.isLoggedIn)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.username) + " (" + _toDisplayString(_ctx.role) + ") ", 1))
                : _createCommentVNode("", true),
              (!_ctx.isLoggedIn)
                ? (_openBlock(), _createBlock(_component_NavBarItem, {
                    key: 3,
                    to: "/",
                    class: "router-link-active router-link-exact-active navitem"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_14
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.isLoggedIn)
                ? (_openBlock(), _createBlock(_component_NavBarItem, {
                    key: 4,
                    to: "/",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.doLogout())),
                    class: "router-link-active router-link-exact-active navitem"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_15
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}